export default __webpack_public_path__ + "static/media/01.1ecf6fdb.jpg";